// extracted by mini-css-extract-plugin
module.exports = {"l1p47b6u":"l1p47b6u","time":"time","tfkvl2n":"tfkvl2n","t1yck6oe":"t1yck6oe","leztxks":"leztxks"};